export default "__VITE_ASSET__DCr9_Ty5__"